module.exports = __webpack_public_path__ + "img/P150T_weapon_140.cd1dd87c.png";